import React, { useEffect, useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import SearchBox from '../components/SearchBox';
import SelectBox from '../components/SelectBox';
import Button from 'react-bootstrap/Button';
import {
  LocationFilterType,
  ReimbursementFilterType,
  SelectOptionType,
} from '../utils/Types';
import { DEFAULT_OPTION } from '../utils/Constant';
import LocationFilter from './LocationFilter';
import { useAppDispatch, useAppSelector } from '../store/redux-hooks';
import {
  fetchReimbursementTaskNames,
  reimbursementSelector,
} from '../features/reimbursementSlice';

interface IReimbursementFilterProps {
  showLocationFilter: boolean;
  onApplyFilters: (ReimbursementFilter: ReimbursementFilterType) => void;
}

const defaultReimbursementFilter: ReimbursementFilterType = {
  taskId: '',
  taskName: DEFAULT_OPTION,
  zone: DEFAULT_OPTION,
  state: DEFAULT_OPTION,
  district: DEFAULT_OPTION,
  city: DEFAULT_OPTION,
};

const ReimbursementFilter: React.FunctionComponent<
  IReimbursementFilterProps
> = ({ showLocationFilter, onApplyFilters }: IReimbursementFilterProps) => {
  const [filter, setFilter] = useState<ReimbursementFilterType>(
    defaultReimbursementFilter
  );
  const optionsTaskName: SelectOptionType[] = useAppSelector(
    reimbursementSelector
  ).taskNameList;

  const dispatch = useAppDispatch();

  const onResetFilter = () => {
    onApplyFilters(defaultReimbursementFilter);
    setFilter(defaultReimbursementFilter);
  };

  useEffect(() => {
    dispatch(fetchReimbursementTaskNames());
  }, []);

  return (
    <div className="border rounded ps-3 pt-2 pe-3 pb-3">
      <Row>
        <Col xs={6} md={2}>
          <SearchBox
            label="Search by Task Id"
            placeHolder="Search"
            value={filter.taskId}
            onChange={(e: any) => {
              setFilter({
                ...filter,
                taskId: e.target.value,
              });
            }}
          />
        </Col>
        <Col xs={6} md={3}>
          <SelectBox
            label="Search by Task Name"
            value={filter.taskName}
            options={optionsTaskName}
            onChange={(value: any) => {
              setFilter({
                ...filter,
                taskName: value,
              });
            }}
          />
        </Col>
      </Row>
      {showLocationFilter && (
        <LocationFilter
          filterData={{
            zone: filter.zone,
            state: filter.state,
            district: filter.district,
            city: filter.city,
          }}
          setLocationFilter={(locationFilter: LocationFilterType) => {
            setFilter({
              ...filter,
              zone: locationFilter.zone,
              state: locationFilter.state,
              district: locationFilter.district,
              city: locationFilter.city,
            });
          }}
        />
      )}
      <Row>
        <Col xs={6} md={3} className="d-flex align-items-center pt-1">
          <Button
            variant="primary"
            className="cl-btn-primary"
            onClick={() => {
              onApplyFilters(filter);
            }}
          >
            Search
          </Button>
          <Button
            variant="outline-primary"
            className="mx-2 cl-btn-outline-primary"
            onClick={() => {
              onResetFilter();
            }}
          >
            Reset
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default ReimbursementFilter;
